export * from "ce/utils/preloadHelpers";

export const getBaseURL = () => {
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any).CDN_URL || "/";
};
